import React from "react";
import { Skeleton } from "../ui/skeleton";

export const tracking_subservices: string[] = ["Object", "Camera", "Rotoanim"];
export const SERVICE_3D_TRACKING = "3D Tracking";

export const getServiceOrSubserviceBasedOnSubservice = (
  taskService: { id: string; name: string }[],
  subService?: { id: string; name: string } | null,
) => {
  if (subService && taskService[0].name === SERVICE_3D_TRACKING) {
    return [
      {
        id: subService.id,
        name: subService.name,
        _typename: "Service",
      },
    ];
  }
  return [
    {
      id: taskService[0].id,
      name: taskService[0].name,
      _typename: "Service",
    },
  ];
};
export const formatServiceName = (
  serviceName: string,
  subservicename?: string,
) => {
  switch (serviceName) {
    case "3D Tracking":
      return subservicename || "Tracking";
    case "Rotoscoping":
      return "Roto";
    case "Compositing":
      return "Comp";
    case "2D Tracking":
      return "2D Track";
    default:
      return serviceName;
  }
};
export interface Service {
  id: string;
  name: string;
  subservicename?: string;
}

interface ServiceDotsProps {
  className?: string;
  innerClassName?: string;
  services: Service | Service[];
  flatTop?: boolean;
  transparent?: boolean;
  showDot?: boolean;
  border?: boolean;
  square?: boolean;
  colorBorder?: boolean;
  colorText?: boolean;
  capitalize?: boolean;
  noWidth?: boolean;
  bgOpacity30?: boolean;
  textSize?: "xs" | "sm";
  showServiceDots?: boolean;
}

const ServiceDots: React.FC<ServiceDotsProps> = ({
  className = "",
  innerClassName = "",
  services,
  flatTop = false,
  transparent = false,
  showDot = false,
  border = false,
  square = false,
  colorBorder = false,
  colorText = false,
  capitalize = false,
  noWidth = false,
  bgOpacity30 = false,
  textSize = "sm",
  showServiceDots = true,
}) => {
  const serviceList = Array.isArray(services) ? services : [services];

  const colorMap: Record<
    string,
    { bg: string; border: string; dot: string; bg30?: string; text: string }
  > = {
    Rotoscoping: {
      bg: "bg-service-rotoscoping",
      bg30: "bg-service-rotoscoping/30",
      border: "border-service-rotoscoping",
      dot: "bg-service-rotoscoping",
      text: "text-service-rotoscoping",
    },
    Paint: {
      bg: "bg-service-paint",
      bg30: "bg-service-paint/30",
      border: "border-service-paint",
      dot: "bg-service-paint",
      text: "text-service-paint",
    },
    "3D Tracking": {
      bg: "bg-service-3d-tracking",
      bg30: "bg-service-3d-tracking/30",
      border: "border-service-3d-tracking",
      dot: "bg-service-3d-tracking",
      text: "text-service-3d-tracking",
    },
    Compositing: {
      bg: "bg-service-compositing",
      bg30: "bg-service-compositing/30",
      border: "border-service-compositing",
      dot: "bg-service-compositing",
      text: "text-service-compositing",
    },
    Assets: {
      bg: "bg-service-assets",
      bg30: "bg-service-assets/30",
      border: "border-service-assets",
      dot: "bg-service-assets",
      text: "text-service-assets",
    },
    "2D Tracking": {
      bg: "bg-[#3685DE]",
      bg30: "bg-[#3685DE]/30",
      border: "border-[#3685DE]",
      dot: "bg-[#3685DE]",
      text: "text-[#3685DE]",
    },
    default: {
      bg: "bg-purple-700",
      border: "border-purple-700",
      dot: "bg-purple-700",
      text: "text-purple-700",
    },
  };

  const sizes = {
    xs: "text-xs",
    sm: "text-sm",
  };
  return (
    <div className={`${className} flex flex-wrap gap-x-5 gap-y-1`}>
      {showServiceDots &&
        serviceList.map((service) => {
          const color = colorMap[service.name] || colorMap["default"];
          const bgClass = transparent
            ? "bg-transparent"
            : bgOpacity30
              ? color.bg30
              : color.bg;
          const borderClass = border
            ? "border-2"
            : colorBorder
              ? `border ${color.border}`
              : "border-transparent";

          const dotClass = `w-2 h-2 rounded-full ${color.dot}`;
          const textColor = colorText
            ? color.text
            : showDot
              ? "text-[#586470] font-extralight dark:text-[#C3C3C3]"
              : "text-white";

          const borderRadiusClass = showDot
            ? "rounded-sm"
            : square
              ? "rounded-sm"
              : flatTop
                ? "rounded-b-2xl rounded-t-none"
                : "rounded-full";

          const capitalizeClass = capitalize ? "uppercase" : "";
          const widthClass = noWidth ? "" : "w-28";
          return (
            <div
              key={service.id}
              className={`flex items-center justify-center gap-2 px-4 py-1 ${sizes[textSize]} font-medium ${bgClass} ${widthClass} ${borderRadiusClass} ${capitalizeClass} ${borderClass} ${textColor} ${innerClassName}`}
            >
              {showDot && <div className={dotClass} />}
              <div className={showDot ? "mr-auto text-left" : ""}>
                {formatServiceName(service.name, service.subservicename)}
              </div>
            </div>
          );
        })}
    </div>
  );
};
export default ServiceDots;

export const ServiceDotsSkeleton = () => {
  return (
    <div className="flex flex-wrap">
      <div>
        <Skeleton className="h-7 w-30 rounded-b-2xl rounded-t-none" />
      </div>
    </div>
  );
};
